import PermissionGuard from 'components/Global/PermissionGuard';
import DeductionComponent from 'components/Settings/PayrollSettings/Deduction';

export const Deduction = () => {
	return (
		<PermissionGuard permission="Allow_Deduction_Code">
			<DeductionComponent />
		</PermissionGuard>
	);
};
